export const SemanticType = {
  MOST_FAVOURABLE: 'MostFavourable',
  FAVOURABLE: 'Favourable',
  NEUTRAL: 'Neutral',
  AVERAGE: 'Average',
  LESS_FAVOURABLE: 'LessFavourable',
  UNFAVOURABLE: 'Unfavourable',
  UNKNOWN: 'Unknown',
};

export const SemanticTypeValue = {
  [SemanticType.UNKNOWN]: 6,
  [SemanticType.NEUTRAL]: 5,
  [SemanticType.MOST_FAVOURABLE]: 4,
  [SemanticType.FAVOURABLE]: 3,
  [SemanticType.AVERAGE]: 2,
  [SemanticType.LESS_FAVOURABLE]: 1,
  [SemanticType.UNFAVOURABLE]: 0,
};
